<template>
    <div>
        <!-- page title -->
        <div class="mb-2">
            <h1 class="page__title">Пополнить баланс</h1>
        </div>

        <balanceCard />

        <br />

        <tariffCard />
    </div>
</template>

<script>
import balanceCard from '@/components/balanceCard';
import tariffCard from '@/components/tariffCard';

export default {
    components: {
        balanceCard,
        tariffCard,
    },

    data: () => ({}),

    mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
</style>
